import { render, staticRenderFns } from "./loginNew.vue?vue&type=template&id=710e7ea0&scoped=true&"
import script from "./loginNew.vue?vue&type=script&lang=js&"
export * from "./loginNew.vue?vue&type=script&lang=js&"
import style0 from "./loginNew.vue?vue&type=style&index=0&id=710e7ea0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710e7ea0",
  null
  
)

export default component.exports